module.exports = __webpack_public_path__ + "img/2023big13.5f788e3a.png";